import address from './address.json';
import asm from './asm.json';
import cart from './cart.json';
import checkout from './checkout.json';
import common from './common.json';
import myAccount from './myAccount.json';
import organization from './organization.json';
import payment from './payment.json';
import product from './product.json';
import productImageZoom from './productImageZoom.json';
import pwa from './pwa.json';
import savedCart from './savedCart.json';
import uigBranches from './uigBranches.json';
import uigCart from './uigCart.json';
import uigComponents from './uigComponents.json';
import uigMyAccount from './uigMyAccount.json';
import uigNews from './uigNews.json';
import uigOrganization from './uigOrganization.json';
import uigOrgUser from './uigOrgUser.json';
import uigProduct from './uigProduct.json';
import uigSavedCart from './uigSavedCart.json';
import uigUnits from './uigUnits.json';
import uigWishList from './uigWishList.json';
import user from './user.json';
import userAccount from './userAccount.json';
import userProfile from './userProfile.json';
import wishlist from './wishlist.json';

export const de = {
  address,
  asm,
  cart,
  checkout,
  common,
  myAccount,
  organization,
  payment,
  product,
  productImageZoom,
  pwa,
  savedCart,
  uigBranches,
  uigCart,
  uigComponents,
  uigMyAccount,
  uigNews,
  uigOrganization,
  uigOrgUser,
  uigProduct,
  uigSavedCart,
  uigUnits,
  uigWishList,
  user,
  userAccount,
  userProfile,
  wishlist,
};
